import { Box, Grid, VStack } from "@/ui";

/**
 * Loading component for search results
 */
export const Loading = () => {
  return (
    <Grid className="grid-cols-2 gap-x-4 gap-y-4">
      <VStack className="space-y-2">
        <Box className="skeleton h-32 w-full" />
        <Box className="skeleton h-4 w-28" />
        <Box className="skeleton h-4 w-full" />
      </VStack>
      <VStack className="space-y-2">
        <Box className="skeleton h-32 w-full" />
        <Box className="skeleton h-4 w-28" />
        <Box className="skeleton h-4 w-full" />
      </VStack>
      <VStack className="space-y-2">
        <Box className="skeleton h-32 w-full" />
        <Box className="skeleton h-4 w-28" />
        <Box className="skeleton h-4 w-full" />
      </VStack>
      <VStack className="space-y-2">
        <Box className="skeleton h-32 w-full" />
        <Box className="skeleton h-4 w-28" />
        <Box className="skeleton h-4 w-full" />
      </VStack>
    </Grid>
  );
};
